var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src.length)?_c('div',{ref:"thumbnail",staticClass:"thumbnail",on:{"click":_vm.zoom}},[_c('img',{staticClass:"thumbnail__image",attrs:{"src":_vm.src,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }